import Axios from 'axios';
import Vue from 'vue';
import i18n from '../../../i18n';
import { API_HOST } from '../../../config/app-const';
import { CATEGORIES } from '../../../config/const';
import { normalize } from '../../../helpers/pagination';

const actions = {
  getAutomatedTags: ({ commit, rootState, state }, { projectId, pagination, search }) => {

    let query = '?';
    const normalizedPagination = normalize(pagination);

    Object.keys(normalizedPagination).map((param, i) => {
      query += `${param}=${normalizedPagination[param]}${i !== Object.keys(normalizedPagination).length - 1 ? '&' : ''}`;
    });

    if (search) {
      query += (query.length > 0 ? '&' : '?') + 'search=' + search;
    }

    const { accessToken } = rootState.user.user.data;
    const config = {
      headers: { Authorization: `Token token=${accessToken}` }
    };

    return Axios.get(`${API_HOST}/analysis/${projectId}/tags/automated_tags${query}`, config)
      .then(response => {
        return response.data.data;
      })
      .catch(error => {
        Vue.notify({
          group: 'store_notifications',
          type: 'error',
          text: i18n.t('messages.request.error')
        });
        console.error(error);
      });
  },

  updateAutomatedTagAlias: ({ commit, rootState, state }, { id, projectId, data }) => {
    const { accessToken } = rootState.user.user.data;
    const config = {
      headers: { Authorization: `Token token=${accessToken}` }
    };

    return Axios.put(`${API_HOST}/analysis/${projectId}/tags/automated_tags/${id}`, data, config)
      .then(response => {
        return response.data.data;
      })
      .catch(error => {
        const errorMessage = i18n.te('tag.form.errors.' + error.response.data.message) ? i18n.t('tag.form.errors.' + error.response.data.message) : i18n.t('messages.request.error');
        Vue.notify({
          group: 'store_notifications',
          type: 'error',
          text: errorMessage
        });
        console.error(error);
      });
  }
};

export default {
  namespaced: true,
  actions
};